import React, { lazy, Suspense } from 'react';
import PrivateRoute from "../../routes/PrivateRoute";
import { Spinner } from '../Common/Spinner';

const ProductFeatureListTable = lazy(() => import('./List/ProductFeatureListTable'));
const ProductFeatureForm = lazy(() => import('./ProductFeatureForm'));

const ProductFeatureRouter = (props) => (
  <Suspense fallback={<Spinner />}>
    <PrivateRoute path="/list/product_features" searchString={props.searchString} component={ProductFeatureListTable} exact />
    <PrivateRoute path="/product_feature/:id?" component={ProductFeatureForm} exact />
  </Suspense>
);

export default ProductFeatureRouter;